<template>
	<div class="usePowerUnitBody custom-scrollbar">
		<!-- 通用-单位信息 -->
		<unitInfo class="marginRight smallWindow"></unitInfo>
		<!-- 通用-月事件告警统计环比 -->
		<workStateNoWork class="smallWindow"></workStateNoWork>
		<kjOverView class="marginTop bigWindow" v-if="showKj"></kjOverView>
		<!-- 通用-单位日负荷 -->
		<dayInfo class="marginTop bigWindow"></dayInfo>
		<!-- 通用-单位年统计 -->
		<yearOrMonthkWh class="marginTop bigWindow"></yearOrMonthkWh>
		<div style="height: 10px;width: 100%;"></div>
	</div>
</template>

<script>
	import unitInfo from '@/page/unitProfile/navyUsePowerUnit/unitInfo.vue'
	import workStateNoWork from '@/page/unitProfile/navyUsePowerUnit/workStateNoWork.vue'
	import dayInfo from '@/page/unitProfile/navyUsePowerUnit/dayInfo.vue'
	import yearOrMonthkWh from '@/page/unitProfile/navyUsePowerUnit/yearOrMonthkWh.vue'
	import kjOverView from '@/page/unitProfile/navyUsePowerUnit/kjOverView.vue'
	import unitStore from '@/cache/unitStore.js'
	export default {
		components: {
			unitInfo,
			workStateNoWork,
			dayInfo,
			yearOrMonthkWh,
			kjOverView,
		},
		props: [],
		data() {
			return {}
		},
		created() {

		},
		mounted() {},
		destroyed() {},
		computed: {
			showKj() {
				//是否显示康晋的定制看板
				return this.$router.currentRoute.path == '/kjOverView'
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>
	.usePowerUnitBody {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		height: calc(100% - 20px);
		padding: 1%;
		overflow: auto;
	}
	
	.smallWindow {
		width: calc(50% - 6px);
		height: 270px;
	}
	
	.marginRight {
		margin-right: 8px;
	}
	
	.marginTop {
		margin-top: 8px;
	}
	
	.bigWindow {
		width: 100%;
		height: 270px;
	}
</style>
